import React from 'react'
import Edit from '../crud/edit'
import fields from './fields'
import menuItems from './menuItems'

const EditTopic = (props) => {
  return (
    <Edit
// @ts-ignore
      title='Editing Forum Topic'
      fields={fields}
      apiPath={`admin/topics/${props.params.topicId}`}
      successRedirectPath='/write-now/topics'
      buildMenuItems={menuItems}
    />
  )
}

export default EditTopic
